<script>
    export default {
        data: () => ({
            comparatorItems: [
                { id: 1, label: 'Tasa' },
                { id: 2, label: 'Comisión por apertura' },
                { id: 3, label: 'Comisión por facturación menor' },
                { id: 4, label: 'Costo del equipo' },
                { id: 5, label: 'Tasa de meses sin intereses' },
                { id: 6, label: 'Tiempo para depósito en cuenta' },
                { id: 7, label: 'Pago con Puntos BBVA' },
                { id: 8, label: '¿Cuánto estaría recibiendo? <br> Ejemplo: venta de $1000.00 sin MSI incluyendo IVA' },
            ],
            bbva:{ 
                id: 9,
                name: 'BBVA',
                logo: 'bbva',
                rate: '2.50% + IVA',
                openingFee: 'Sin comisión',
                billingFee: 'Sin comisión',
                equipmentCost: '¡La primera sin costo! <br> Adicional $150 al mes',
                rateIFM: '3 a 12 meses sin intereses <br> Desde 5.57% a 16.7%',
                timeDeposit: 'Al siguiente día hábil',
                bbvaPoints: 'Sí admite pagos con BBVA. <br> A tu cliente le podría salir <br> ¡sin costo tu producto!',
                receive: '$974.71' 
            },
            banks: [
                { 
                    id: 1, 
                    name: 'Clip', 
                    logo: 'clip', 
                    rate: '3.60% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: 'Desde $129.00 <br> a $7,197.00',
                    rateIFM: '3 a 24 meses sin intereses <br> Desde 4.57% a 27.17% + IVA',
                    timeDeposit: 'Al siguiente día natural',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: '$963.58 <br> ¡Casi 10 pesos que pudo haber ganado más por ésta compra!'
                },
                { 
                    id: 2, 
                    name: 'Mercado Pago', 
                    logo: 'mercado-pago', 
                    rate: '3.50% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: 'Desde $119.00 <br> a $599.00',
                    rateIFM: '3 a 24 meses sin intereses <br> Desde 4.69% a 27.29% + IVA',
                    timeDeposit: 'Inmediato <br> (sólo a cuenta de Mercado Pago)',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: '$964.594 <br> ¡Imagina multiplicar esta diferencia por todas las ventas al año!'
                },
/*                 { 
                    id: 3, 
                    name: 'Santander', 
                    logo: 'santander', 
                    rate: '1.50% / AMEX 2.90%',
                    openingFee: '$299',
                    billingFee: '$400 (mín. $50,000)',
                    equipmentCost: 'Alámbrica sin costo <br> Inalámbrica $150 mensual',
                    rateIFM: '3.50% a 15%',
                    timeDeposit: 'Al siguiente día hábil',
                    bbvaPoints: 'No permite pago con Puntos BBVA'
                }, */
                 { 
                    id: 4, 
                    name: 'Banorte', 
                    logo: 'banorte', 
                    rate: '0.75% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: '$350 Mínimo a <br> facturación: $35,000',
                    equipmentCost: '$299',
                    rateIFM: '3 a 12 meses sin intereses <br> Desde 3.5% a 11.5% + IVA',
                    timeDeposit: 'Al siguiente día hábil',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: ''
                },
                /* { 
                    id: 5, 
                    name: 'Inbursa', 
                    logo: 'inbursa', 
                    rate: '3% TDC / 2% TDD',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: 'Inalámbrica GPRS $550+IVA mensuales/ <br> Modelo wifi $350+IVA mensuales/ <br> Alámbrico con Ethernet $240+IVA/ <br>Sin información Análoga $240+IVA mensuales',
                    equipmentCost: 'Inalámbrica GPRS $550+IVA mensuales',
                    rateIFM: 'Sin información',
                    timeDeposit: 'Sin información',
                    bbvaPoints: 'No permite pago con Puntos BBVA'
                }, */ 
                { 
                    id: 6, 
                    name: 'Citibanamex', 
                    logo: 'banamex', 
                    rate: '1.50% + IVA',
                    openingFee: '$290',
                    billingFee: 'Sin comisión',
                    equipmentCost: 'Lectora de pago: $799',
                    rateIFM: '3 a 12 meses sin intereses <br> Desde 5.75% a 16.63% + IVA',
                    timeDeposit: 'Día seguiente hábil',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: ''
                },
                { 
                    id: 7, 
                    name: 'Scotiabank', 
                    logo: 'scotiabank', 
                    rate: 'TDD: 2.65% + IVA <br> TDC: 2.35% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: '$499.00 Más $50.00 <br> mensuales de renta de equipo',
                    rateIFM: '3 a 18 meses sin intereses <br> Desde 3.5% a 15% +IVA',
                    timeDeposit: 'Al siguiente día natural',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: '$973.19 <br> ¡Todo suma, su ganancia subiría!'
                },
                { 
                    id: 8, 
                    name: 'Zettle', 
                    logo: 'zettle', 
                    rate: '3.5% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: '$199',
                    rateIFM: '3 a 12 meses sin intereses <br> Desde 4% a 12% + IVA',
                    timeDeposit: 'Al siguiente día natural',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: '$964.594 <br> ¡Imagina multiplicar esta diferencia por todas las ventas al año!'
                },
                { 
                    id: 9, 
                    name: 'NetPay', 
                    logo: 'netpay', 
                    rate: '2.6% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: '$749',
                    rateIFM: '3 a 18 meses sin intereses <br> Desde 3.95% a 12% + IVA',
                    timeDeposit: 'Al siguiente día natural',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: '$973.69 <br> ¡Todo suma, su ganancia subiría!'
                },
                { 
                    id: 10, 
                    name: 'Konfio', 
                    logo: 'konfio', 
                    rate: '1.79% + IVA',
                    openingFee: 'Sin comisión',
                    billingFee: 'Sin comisión',
                    equipmentCost: '$599',
                    rateIFM: '3 a 12 meses sin intereses <br> Desde 3.95% a 12% + IVA',
                    timeDeposit: 'Al siguiente día natural',
                    bbvaPoints: 'No permite pago con Puntos BBVA',
                    receive: ''
                },
            ],
            selectedBanks: [],
            showComparator: false
        }),
        computed:{
            hiddeReceive(){
                console.log(this.selectedBanks.find(item => item.id === 4) !== undefined || this.selectedBanks.find(item => item.id === 6) !== undefined || this.selectedBanks.find(item => item.id === 10) !== undefined );
                return this.selectedBanks.find(item => item.id === 4) || this.selectedBanks.find(item => item.id === 6) || this.selectedBanks.find(item => item.id === 10) 
            }
        },
        methods: {
            selectBank(id){
                const isInArr = this.selectedBanks.find(item => item.id === id ) !== undefined;
                if (isInArr) return

                if (this.selectedBanks.length === 2) this.selectedBanks.shift()
                const item = this.banks.find(item => item.id === id)
                this.selectedBanks.push(item)
            },
            elSelected(id){
                const exist = this.selectedBanks.find(item => item.id === id ) !== undefined;
                return exist
            },
            toggleComparator(){
                this.showComparator = !this.showComparator
                this.$emit('stepTwo')
            },
            hiddeComparator(){
                this.selectedBanks = []
                this.showComparator = false
                this.$emit('stepTwo')
            },
            bankFromSelect(event) {
                const id = Number(event.target.value)
                this.selectBank(id)
            }
        }
    }
</script>

<template>
    <div class="comparator">
        <!-- GRID BANKS -->
        <div v-if="!showComparator">
            <div class="box box--white py-10 px-20 rounded-20 mb-10">
                <p class="tx-24 tx-center tx-blue-1 mb-15">
                    Selecciona hasta 2 opciones para comparar:
                </p>

                <div class="grid grid-cols-4 mb-9">
                    <div class="grid-item grid place-items-center h-50 border-1 cursor-pointer transition-100 px-8" :class="elSelected(item.id) && 'selected'" v-for="item in banks" :key="item.name" @click="selectBank(item.id)">
                        <img :src="require(`./assets/images/banks/${item.logo}.png`)" alt="">
                    </div>
                </div>

                <button class="btn btn--blue-1 tx-white flex w-60 mx-auto" @click="toggleComparator()" v-if="selectedBanks.length > 0">
                    Comparador
                </button>
            </div>
        </div>

        <!-- COMPARATOR  -->
        <div class="mb-10" v-if="showComparator">
            <div class="relative flex align-center mb-8">
                <div class="flex align-center w-fit cursor-pointer absolute" @click="hiddeComparator()">
                    <img class="mr-2 -mb-1" src="./assets/images/arrow-l.png" alt="">
                    Regresar
                </div>


                <div class="form-group w-90 mx-auto mb-0">
                    <select class="form-input form-input-select" name="" id="" @change="bankFromSelect($event)">
                        <option disabled selected>
                            Compara con otros medios de pago
                        </option>
                        <option :value="item.id" v-for="item in banks" :key="item.name">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="box bg-purple-1 py-8 px-10 rounded-20">
                <div class="gs:grid">

                    <!-- COL 1 -->
                    <div class="col-6">
                        <table class="table tx-white w-100pr">
                            <tr class="table-row">
                                <td class="table-cell"><div class="cell-content"></div></td>
                            </tr>
                            <tr class="table-row" v-for="item in comparatorItems" :key="item.label" >
                                <td class="table-cell">
                                    <div class="cell-content flex align-center" :class="item.id === 8 && hiddeReceive ? 'hidden-i' : ''">
                                        <div class="grid place-items-center square h-13 mr-2">
                                            <img class="" :src="require(`./assets/images/icon-comparator/${item.id}.png`)" alt="">
                                        </div>
                                        <span v-html="item.label"></span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="col-18">
                        <div class="grid-comparator gs:grid">
                            <!-- COL 2 -->
                            <div class="border-x-1" :class="selectedBanks.length === 2 ? 'col-8' : 'col-12'">
                                <table class="table table-comparator tx-white tx-center w-100pr">
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content">
                                                <img class="h-7" :src="require(`./assets/images/banks/${bbva.logo}.png`)" alt="">
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.rate"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.openingFee"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.billingFee"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.equipmentCost"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.rateIFM"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.timeDeposit"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.bbvaPoints"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row" v-if="!hiddeReceive">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="bbva.receive"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- COLS TO COMPARATE -->
                            <div class="cols-banks" :class="selectedBanks.length === 1 ? 'col-12' : 'col-8'" v-for="(item, index) in selectedBanks" :key="index">
                                <table class="table table-comparator tx-white tx-center w-100pr">
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" :class="selectedBanks.length === 1 ? 'px-25' : 'px-10'">
                                                <img class="h-16 max-h-fit" :src="require(`./assets/images/banks/${item.logo}.png`)" alt="">
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.rate"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.openingFee"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.billingFee"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.equipmentCost"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.rateIFM"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.timeDeposit"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.bbvaPoints"></div>
                                        </td>
                                    </tr>
                                    <tr class="table-row" v-if="!hiddeReceive">
                                        <td class="table-cell">
                                            <div class="cell-content" v-html="item.receive"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ul class="tx-12 tx-blue-2 tx-leading-soft m-0 py-0 bullet-none p-0">
            <li>
                Material de uso interno
            </li>
            <li>
                Todos los precios están expresados en pesos mexicanos.
            </li>
            <li>
                La actualización del material es con base en la información proporcionada por Marketing Intelligence de manera semestral. (última actualización junio 2026)
            </li>
            <li>
                Fuente: Investigación realizada mediante la técnica de Mystery Shopping en Sucursales de la CDMX, Líneas de Atención Telefónica y/u otros canales de contacto; así como Desk Reserch en páginas web oficiales de las instituciones.
                <br>   
                Se utilizó el siguiente perfil como cliente nuevo: Venta de autopartes; ventas anuales de $5 MDP y 2 sucursales ubicadas en CDMX.."							
            </li>
            <li>
                La tasa de descuento aplica por cada evento (cobro).
            </li>
            <li>
                Aplican restricciones.
            </li>
        </ul>
    </div>
</template>
<style lang="scss" scoped>
    .hidden-i{
        display: none!important;
    }

    li::marker {
        color: #8be1e9;
    }

    .square{
        aspect-ratio: 1 / 1;
    }

    .grid-item.selected{
        border: 6px solid #8be1e9;
    }

    @media screen and (min-width: 1140px) {
        .grid-item:hover{
            border: 6px solid #8be1e9;
        }
    }

    .table{
        border-collapse: collapse;
    }

    .cell-content{
        display: flex;
        align-items: center;
        min-height: 60px;
    }

    .table-comparator .cell-content{
        justify-content: center;
    }

    .grid-comparator .cols-banks:not(:last-child){
        border-right-width: 1px;
    }
</style>